<template>
    <div>

        <div class="">

            <p class="mt-2">
                <b-icon-exclamation-circle-fill v-if="showIcon" class="color-red" /> {{message}}
            </p>

            <ul v-if="list != null" class="list-unstyled list-simple">
                <li v-for="(mes, idx) in list" :key="idx">{{mes}}</li>
            </ul>

        </div>

        <div v-if="showRemember">
            <input type="checkbox" v-model="blnRemember" id="chkRemember" /><label for="chkRemember"> {{ $t('general.rememberMyChoice') }}</label>
        </div>
        

        <div class="text-right mb-2 border-top pt-4">
            <button v-on:click="Bus.$emit('no-pressed', blnRemember)" class="medium-button blue-gradient d-inline-block mr-3"><b-icon-x-circle-fill class="mr-1" /> {{ $t('general.no') }}</button>
            <button v-if="modeIsDeleting" v-on:click="Bus.$emit('yes-pressed', blnRemember)" class="medium-button bg-red d-inline-block"><b-icon-x-circle-fill class="mr-1" /> {{ $t('general.delete') }}</button>
            <button v-else v-on:click="Bus.$emit('yes-pressed', blnRemember)" class="medium-button bg-green d-inline-block"><b-icon-x-circle-fill class="mr-1" /> {{ $t('general.yes') }}</button>
        </div>
    </div>

</template>

<script>
    import Bus from '@/Bus.js';

    export default {
        name: 'SimpleAcceptDecline',
        data: function () {

            return {
                Bus: Bus, //enables use of event bus directly in html
                blnRemember: false
            }

        },
        components: {
        },
        props: {
            message: String,
            list: Array,
            showRemember: { type: Boolean, default: false },
            showIcon: { type: Boolean, default: true },
            modeIsDeleting: {type: Boolean, default: true}
        },
        mounted: function () {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        },
        destroyed: function() {
            Bus.$off('yes-pressed')
            Bus.$off('no-pressed')
        },
    }
</script>
